import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

@Pipe({
   name: 'formatDateIso'
})
export class FormatDateIsoPipe implements PipeTransform {
   transform(bod: string | Date | undefined): string {
      if (!bod) return '';
      try {
         return format(new Date(bod), 'yyyy-MM-dd');
      } catch {
         return '';
      }
   }
}
